import { useState } from 'react'

import { generateEmailThreadSummary } from '../../../../../../api'
import { EMPTY_OBJECT } from '../../../../../../constants/common'
import { useAsyncCallback } from '../../../../../../hooks'
import { useRequestProfileTabEmailsSummaryExpandContext } from '../../../RequestProfileTabEmails.hooks'

export function useRequestProfileTabEmailsThreadModalSummaryProps({
  entityData,
  mailUuid,
  onReloadProfile,
}) {
  const [summaryData, setSummaryData] = useState(entityData?.summary ?? null)

  const { isThreadSummaryCollapsed, toggleThreadSummaryExpanded } =
    useRequestProfileTabEmailsSummaryExpandContext()

  const [previousSource, setPreviousSource] = useState({
    mailUuid,
    summary: entityData?.summary,
  })

  const isThreadChanged = mailUuid !== previousSource.mailUuid
  const isSummaryChanged = entityData?.summary !== previousSource.summary

  if (isThreadChanged || isSummaryChanged) {
    setPreviousSource({ mailUuid, summary: entityData?.summary })
    setSummaryData(isThreadChanged ? null : (entityData?.summary ?? null))
  }

  function mergeSummaryData(nextData) {
    setSummaryData(prev => ({ ...(prev ?? EMPTY_OBJECT), ...nextData }))
  }

  const handleSummaryReload = useAsyncCallback(async () => {
    await onReloadProfile()

    return { data: { email_summary: null } }
  }, [onReloadProfile])

  function handleToggleExpanded(isExpanded) {
    toggleThreadSummaryExpanded(mailUuid, isExpanded)
  }

  // The initial-generate state renders the widget without a header, so a
  // collapsed state would leave no way to expand it back.
  const isInitialGenerateState = summaryData?.can_generate && !summaryData?.text

  const isExpanded = isInitialGenerateState
    ? true
    : !isThreadSummaryCollapsed(mailUuid)

  return {
    data: summaryData,
    generateSummaryParams: { request_thread_id: mailUuid },
    isArchived: entityData?.soft_archived,
    isExpanded,
    onError: mergeSummaryData,
    onGenerateSummary: generateEmailThreadSummary,
    onReloadData: handleSummaryReload,
    onSuccess: mergeSummaryData,
    onToggleExpanded: handleToggleExpanded,
  }
}
